import React from 'react'
import { useContext } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import BookTripDetails from './BookTripDetails'
import BookTripFlextime from './BookTripFlextime'
import MyLocation from '../comps/MyLocation.js'
import TripInfo from '../comps/TripInfo'
import {AppContext} from '../context/AppContext'
import BookTripCommute from './BookTripCommute'
import BookTripFooter from './BookTripFooter'
import BookTripDone from './BookTripDone'
import BookTripIphone from './BookTripIphone'
import BookTripFinal from './BookTripFinal'

const BookTrip = () => {
  let match = useRouteMatch()
  const location = useLocation()
  console.log(match.path)

  const {prevPage, setPrevPage, nextPage, setNextPage} = useContext(AppContext) 
  



  return (
    <div ID="book-travel" className="content">
        <div className="content-wrap">
          
          <Switch>
            <Route exact path={match.path}>
              <MyLocation />
              <BookTripDetails />
              <BookTripFooter />
            </Route>
            <Route path={`${match.path}/flextime`} >
              <BookTripFlextime />
              <BookTripFooter />
            </Route>
            <Route path={`${match.path}/summary`} >
              <BookTripCommute/>
              <BookTripFooter />
            </Route>
            <Route path={`${match.path}/done`} >
              <BookTripDone />
            </Route>
            <Route path={`${match.path}/confirmed`} >
              <BookTripFinal />
            </Route>
            <Route path={`${match.path}/iphonescreen`} >

                <BookTripIphone />
              
            </Route>
          </Switch>

        </div>
       
    </div>
  )
}

export default BookTrip
